import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await register(email, password, name);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome to Wealth First.");
      navigate(next);
    } else {
      setError(res.error);
    }
  };

  return (
    <div data-testid="register-page" className="min-h-screen flex items-center justify-center px-6 pt-24 pb-12">
      <div className="w-full max-w-md">
        <p className="eyebrow mb-4">By Invitation</p>
        <h1 className="font-display text-5xl md:text-6xl mb-3">Become a Member</h1>
        <p className="text-sm mb-10" style={{ color: "var(--ink-muted)" }}>
          Create your account. Choose a tier afterward.
        </p>

        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="eyebrow block mb-2">Full Name</label>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input-line"
              data-testid="register-name"
              autoComplete="name"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-line"
              data-testid="register-email"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2">Password</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-line"
              data-testid="register-password"
              autoComplete="new-password"
            />
          </div>
          {error && <p className="text-sm" style={{ color: "#E08585" }} data-testid="register-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="register-submit" className="btn-brass w-full justify-center">
            {busy ? "Creating…" : "Create Account"}
          </button>
        </form>

        <p className="mt-8 text-sm text-center" style={{ color: "var(--ink-muted)" }}>
          Already a member?{" "}
          <Link to="/login" className="brass-link uppercase tracking-[0.2em] text-xs">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
